/* EMA Product Reviews — self-contained IIFE, no dependencies — v2 */
(function () {
  'use strict';

  // ── CSS ─────────────────────────────────────────────────────────────────────
  const CSS = `
/* ── Outer section — inside .product-info__sticky column ── */
.ema-rv-section {
  background: transparent;
  padding: 0;
  box-sizing: border-box;
  border-top: 1px solid #e5e7eb;
}
.ema-rv-section *,
.ema-rv-section *::before,
.ema-rv-section *::after { box-sizing: border-box; }

/* Heading row — matches .disclosure__title rows exactly */
.ema-rv-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  font-size: calc(var(--body-font-size) * 0.1rem);
  font-weight: 700;
  color: #0e2040;
  margin: 0;
  padding: 18px 0 14px;
  letter-spacing: 0;
  font-family: inherit;
  line-height: 1.3;
}
.ema-rv-heading svg { flex-shrink: 0; color: #f59e0b; }

/* Body */
.ema-rv-body { padding-bottom: 24px; }

.ema-rv-login-prompt {
  font-size: calc(var(--body-font-size) * 0.1rem);
  color: #6b7280;
  margin: 0 0 16px;
  line-height: 1.5;
}
.ema-rv-login-prompt a { color: #0e2040; font-weight: 600; text-decoration: underline; }

/* ── Rating summary ── */
.ema-rv-summary {
  display: flex;
  gap: 20px;
  align-items: center;
  background: #f9fafb;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e5e7eb;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.ema-rv-summary-left { display: flex; flex-direction: column; align-items: center; min-width: 72px; gap: 4px; }
.ema-rv-avg-number { font-size: 2.2rem; font-weight: 700; color: #0e2040; line-height: 1; }
.ema-rv-avg-stars { font-size: calc(var(--body-font-size) * 0.1rem); color: #f59e0b; letter-spacing: 2px; line-height: 1; }
.ema-rv-count-label { font-size: calc(var(--body-font-size) * 0.1rem); color: #9ca3af; margin-top: 2px; }
.ema-rv-summary-right { flex: 1; min-width: 130px; display: flex; flex-direction: column; gap: 5px; }
.ema-rv-bar-row { display: flex; align-items: center; gap: 8px; font-size: calc(var(--body-font-size) * 0.1rem); color: #6b7280; }
.ema-rv-bar-label { min-width: 14px; text-align: right; white-space: nowrap; }
.ema-rv-bar-track { flex: 1; height: 6px; background: #e5e7eb; border-radius: 3px; overflow: hidden; }
.ema-rv-bar-fill { height: 100%; background: #f59e0b; border-radius: 3px; transition: width 0.5s ease; }
.ema-rv-bar-count { min-width: 16px; text-align: left; }

/* ── Write review button ── */
.ema-rv-write-btn {
  display: block;
  width: 100%;
  margin-top: 4px;
  padding: 13px 18px;
  background: #0e2040;
  color: #ffffff;
  border-radius: 6px;
  font-weight: 600;
  font-size: calc(var(--body-font-size) * 0.1rem);
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  text-decoration: none;
  text-align: center;
}
.ema-rv-write-btn:hover { background: #1a3a5c; }

/* ── Empty state ── */
.ema-rv-empty {
  font-size: calc(var(--body-font-size) * 0.1rem);
  color: #6b7280;
  padding: 8px 0 12px;
  line-height: 1.5;
  font-style: normal;
  text-align: left;
}

/* ── Review cards ── */
.ema-rv-cards { margin-top: 4px; display: flex; flex-direction: column; gap: 12px; }
.ema-rv-card {
  background: #f9fafb;
  border-radius: 8px;
  padding: 14px 16px;
  border: 1px solid #e5e7eb;
}
.ema-rv-card-header { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-bottom: 6px; }
.ema-rv-card-stars { color: #f59e0b; font-size: calc(var(--body-font-size) * 0.1rem); letter-spacing: 1px; line-height: 1; }
.ema-rv-card-author { font-weight: 700; color: #0e2040; font-size: calc(var(--body-font-size) * 0.1rem); }
.ema-rv-verified {
  display: inline-block; background: #f0fdf4; color: #166534;
  border: 1px solid #bbf7d0; border-radius: 20px;
  font-size: 12px; padding: 2px 8px; font-weight: 500; line-height: 1.5;
}
.ema-rv-card-date { color: #9ca3af; font-size: calc(var(--body-font-size) * 0.085rem); margin-left: auto; }
.ema-rv-card-title { font-weight: 700; color: #0e2040; margin: 0 0 4px; font-size: calc(var(--body-font-size) * 0.1rem); }
.ema-rv-card-body { color: #374151; line-height: 1.65; font-size: calc(var(--body-font-size) * 0.1rem); margin: 0; }

/* ── Write-review form ── */
.ema-rv-form-wrap {
  background: #f9fafb;
  border-radius: 8px;
  padding: 18px;
  border: 1px solid #e5e7eb;
  margin-top: 16px;
}
.ema-rv-form-wrap h3 { font-size: calc(var(--body-font-size) * 0.1rem); font-weight: 700; color: #0e2040; margin: 0 0 14px 0; }
.ema-rv-star-picker { display: flex; gap: 6px; margin-bottom: 14px; }
.ema-rv-star-picker span {
  font-size: 28px; cursor: pointer; color: #d1d5db;
  transition: color 0.15s, transform 0.1s; line-height: 1; user-select: none;
}
.ema-rv-star-picker span.filled { color: #f59e0b; }
.ema-rv-star-picker span:hover { transform: scale(1.15); }
.ema-rv-form-label { display: block; font-size: calc(var(--body-font-size) * 0.1rem); font-weight: 600; color: #374151; margin-bottom: 4px; }
.ema-rv-form-input,
.ema-rv-form-textarea {
  display: block; width: 100%;
  border: 1px solid #d1d5db; border-radius: 6px;
  padding: 10px 12px; font-size: calc(var(--body-font-size) * 0.1rem); font-family: inherit;
  color: #111827; background: #ffffff; margin-bottom: 12px;
  transition: border-color 0.2s; resize: vertical;
}
.ema-rv-form-input:focus,
.ema-rv-form-textarea:focus { outline: none; border-color: #29b6e8; box-shadow: 0 0 0 3px rgba(41,182,232,0.12); }
.ema-rv-form-textarea { min-height: 90px; }
.ema-rv-form-actions { display: flex; align-items: center; gap: 14px; margin-top: 4px; flex-wrap: wrap; }
.ema-rv-submit-btn {
  padding: 11px 24px; background: #0e2040; color: #ffffff;
  border-radius: 6px; font-weight: 600; font-size: calc(var(--body-font-size) * 0.1rem);
  border: none; cursor: pointer; transition: background 0.2s;
}
.ema-rv-submit-btn:hover { background: #1a3a5c; }
.ema-rv-submit-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.ema-rv-cancel-btn {
  background: none; border: none; color: #6b7280;
  font-size: calc(var(--body-font-size) * 0.1rem); cursor: pointer; padding: 3px 0;
  text-decoration: underline; text-underline-offset: 2px;
}
.ema-rv-cancel-btn:hover { color: #374151; }
.ema-rv-form-error {
  color: #dc2626; font-size: calc(var(--body-font-size) * 0.1rem); margin-top: 8px;
  padding: 10px 12px; background: #fef2f2; border-radius: 6px; border: 1px solid #fecaca;
}
.ema-rv-form-success {
  color: #166534; font-size: calc(var(--body-font-size) * 0.1rem); padding: 12px 16px;
  background: #f0fdf4; border-radius: 8px; border: 1px solid #bbf7d0;
  margin-top: 14px; font-weight: 500;
}

/* ── Load more ── */
.ema-rv-load-more-wrap { text-align: center; margin-top: 14px; }
.ema-rv-load-more {
  display: inline-block; border: 1px solid #d1d5db; background: #ffffff;
  color: #374151; border-radius: 6px; padding: 9px 24px;
  font-size: calc(var(--body-font-size) * 0.1rem); cursor: pointer; transition: border-color 0.2s, color 0.2s;
}
.ema-rv-load-more:hover { border-color: #0e2040; color: #0e2040; }
.ema-rv-load-more:disabled { opacity: 0.5; cursor: not-allowed; }

/* ── Skeleton ── */
.ema-rv-skeleton {
  background: linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%);
  background-size: 400% 100%; animation: ema-rv-shimmer 1.4s ease-in-out infinite;
  border-radius: 5px; height: 14px; margin-bottom: 8px;
}
@keyframes ema-rv-shimmer { 0% { background-position: 100% 0; } 100% { background-position: -100% 0; } }
.ema-rv-skeleton-card { background: #f9fafb; border-radius: 8px; padding: 14px 16px; border: 1px solid #e5e7eb; margin-bottom: 10px; }

/* ── Responsive ── */
@media (max-width: 600px) {
  .ema-rv-summary { flex-direction: column; align-items: flex-start; gap: 12px; }
  .ema-rv-summary-left { flex-direction: row; align-items: baseline; gap: 10px; min-width: unset; }
  .ema-rv-avg-number { font-size: 1.8rem; }
  .ema-rv-card-date { margin-left: 0; width: 100%; }
}

/* ── Inline star badge (product page, below price) ── */
.ema-star-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  margin: 4px 0 8px;
  text-decoration: none;
  /* Ensure the badge sits on its own line and aligns left on all screen sizes */
  width: auto;
  max-width: 100%;
}
.ema-star-badge__stars {
  display: inline-flex;
  gap: 1px;
}
.ema-star-badge__stars svg {
  display: block;
}
.ema-star-badge__count {
  font-size: 0.85rem;
  color: #0e2040;
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 2px;
}

/* ── Search result star badge ── */
.ema-sr-stars {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 3px;
}
.ema-sr-stars__icons {
  display: inline-flex;
  gap: 1px;
}
.ema-sr-stars__count {
  font-size: 0.78rem;
  color: #6b7280;
}
`;

  // ── Inject styles ─────────────────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById('ema-rv-styles')) return;
    const style = document.createElement('style');
    style.id = 'ema-rv-styles';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  // ── Utility helpers ───────────────────────────────────────────────────────────

  function formatDate(unixSeconds) {
    if (!unixSeconds) return '';
    const d = new Date(unixSeconds * 1000);
    return d.toLocaleDateString('en-NZ', { day: 'numeric', month: 'long', year: 'numeric' });
  }

  function starsFilled(rating) {
    const n = Math.round(rating);
    return '★'.repeat(Math.max(0, Math.min(5, n))) + '☆'.repeat(Math.max(0, 5 - Math.min(5, n)));
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // ── State ─────────────────────────────────────────────────────────────────────

  let state = {
    reviews:      [],
    summary:      null,
    page:         1,
    total:        0,
    limit:        10,
    loading:      false,
    hasMore:      false,
    loggedIn:     false,
    customerId:   '',
    customerName: '',
    productHandle: '',
    apiBase:      '',
    formVisible:  false,
    formRating:   0,
    formError:    '',
    formSuccess:  false,
    submitting:   false,
  };

  let root = null;

  // ── API calls ─────────────────────────────────────────────────────────────────

  function fetchReviews(page) {
    const url = `${state.apiBase}/api/reviews/${encodeURIComponent(state.productHandle)}?page=${page}&limit=${state.limit}`;
    return fetch(url).then(r => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.json();
    });
  }

  function submitReview(data) {
    return fetch(`${state.apiBase}/api/reviews`, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(data),
    }).then(r => r.json().then(body => {
      if (!r.ok) throw new Error(body.error || `HTTP ${r.status}`);
      return body;
    }));
  }

  // ── Rendering ─────────────────────────────────────────────────────────────────

  function renderSkeleton() {
    return `
      <div class="ema-rv-skeleton-card">
        <div class="ema-rv-skeleton" style="width:40%;height:14px;"></div>
        <div class="ema-rv-skeleton" style="width:70%;height:12px;margin-top:8px;"></div>
        <div class="ema-rv-skeleton" style="width:90%;height:12px;"></div>
      </div>
      <div class="ema-rv-skeleton-card">
        <div class="ema-rv-skeleton" style="width:35%;height:14px;"></div>
        <div class="ema-rv-skeleton" style="width:80%;height:12px;margin-top:8px;"></div>
      </div>
    `;
  }

  function renderSummaryHtml(summary) {
    if (!summary || summary.count === 0) {
      // Still show the write-a-review prompt even with 0 reviews
      return '';
    }

    const avg  = summary.average ? parseFloat(summary.average).toFixed(1) : '0.0';
    const cnt  = summary.count || 0;
    const dist = summary.distribution || {};

    let barsHtml = '';
    for (let star = 5; star >= 1; star--) {
      const n   = dist[star] || 0;
      const pct = cnt > 0 ? Math.round((n / cnt) * 100) : 0;
      barsHtml += `
        <div class="ema-rv-bar-row">
          <span class="ema-rv-bar-label">${star}★</span>
          <div class="ema-rv-bar-track">
            <div class="ema-rv-bar-fill" style="width:${pct}%"></div>
          </div>
          <span class="ema-rv-bar-count">${n}</span>
        </div>`;
    }

    return `
      <div class="ema-rv-summary">
        <div class="ema-rv-summary-left">
          <div class="ema-rv-avg-number">${avg}</div>
          <div class="ema-rv-avg-stars">${starsFilled(parseFloat(avg))}</div>
          <div class="ema-rv-count-label">${cnt} review${cnt === 1 ? '' : 's'}</div>
        </div>
        <div class="ema-rv-summary-right">${barsHtml}</div>
      </div>`;
  }

  function renderCardHtml(review) {
    const stars    = starsFilled(review.rating);
    const author   = escapeHtml(review.author_name);
    const title    = review.title ? `<div class="ema-rv-card-title">${escapeHtml(review.title)}</div>` : '';
    const body     = escapeHtml(review.body).replace(/\n/g, '<br>');
    const date     = formatDate(review.created_at);
    const verified = review.verified_purchase
      ? `<span class="ema-rv-verified">Verified Purchase</span>`
      : '';

    return `
      <div class="ema-rv-card">
        <div class="ema-rv-card-header">
          <span class="ema-rv-card-stars">${stars}</span>
          <span class="ema-rv-card-author">${author}</span>
          ${verified}
          <span class="ema-rv-card-date">${date}</span>
        </div>
        ${title}
        <p class="ema-rv-card-body">${body}</p>
      </div>`;
  }

  function renderStarPickerHtml(currentRating) {
    let html = '<div class="ema-rv-star-picker">';
    for (let i = 1; i <= 5; i++) {
      const filled = i <= currentRating ? ' filled' : '';
      html += `<span class="ema-rv-star-pick${filled}" data-star="${i}" role="button" aria-label="${i} star${i > 1 ? 's' : ''}">★</span>`;
    }
    html += '</div>';
    return html;
  }

  function renderFormHtml() {
    if (!state.loggedIn) {
      return `<p class="ema-rv-login-prompt"><a href="/account/login">Sign in</a> to leave a review.</p>`;
    }

    if (state.formSuccess) {
      return `<div class="ema-rv-form-success">Thank you for your review! It will appear here shortly.</div>`;
    }

    if (!state.formVisible) {
      return `<button class="ema-rv-write-btn" id="ema-rv-open-form">Write a Review</button>`;
    }

    const errorHtml = state.formError
      ? `<div class="ema-rv-form-error">${escapeHtml(state.formError)}</div>`
      : '';

    return `
      <div class="ema-rv-form-wrap" id="ema-rv-form-wrap">
        <h3>Write a Review</h3>
        <label class="ema-rv-form-label">Your Rating *</label>
        ${renderStarPickerHtml(state.formRating)}
        <label class="ema-rv-form-label" for="ema-rv-title">Review Title</label>
        <input class="ema-rv-form-input" id="ema-rv-title" type="text"
               placeholder="Summarise your experience" maxlength="200"
               value="${escapeHtml(state.formTitleValue || '')}">
        <label class="ema-rv-form-label" for="ema-rv-body">Your Review *</label>
        <textarea class="ema-rv-form-textarea" id="ema-rv-body"
                  placeholder="Tell others what you think (minimum 10 characters)"
                  maxlength="2000">${escapeHtml(state.formBodyValue || '')}</textarea>
        ${errorHtml}
        <div class="ema-rv-form-actions">
          <button class="ema-rv-submit-btn" id="ema-rv-submit"${state.submitting ? ' disabled' : ''}>
            ${state.submitting ? 'Submitting…' : 'Submit Review'}
          </button>
          <button class="ema-rv-cancel-btn" id="ema-rv-cancel">Cancel</button>
        </div>
      </div>`;
  }

  function renderCardsHtml() {
    if (state.loading && state.reviews.length === 0) {
      return renderSkeleton();
    }
    if (state.reviews.length === 0) {
      return `<div class="ema-rv-empty">No reviews yet. Be the first to share your experience!</div>`;
    }
    return state.reviews.map(renderCardHtml).join('');
  }

  function renderLoadMoreHtml() {
    if (!state.hasMore) return '';
    return `
      <div class="ema-rv-load-more-wrap">
        <button class="ema-rv-load-more" id="ema-rv-load-more"${state.loading ? ' disabled' : ''}>
          ${state.loading ? 'Loading…' : 'Load More Reviews'}
        </button>
      </div>`;
  }

  function render() {
    if (!root) return;

    root.innerHTML = `
      <h2 class="ema-rv-heading">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="#f59e0b" stroke="#f59e0b" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
        Customer Reviews
      </h2>
      <div class="ema-rv-body">
        ${renderSummaryHtml(state.summary)}
        ${renderFormHtml()}
        <div class="ema-rv-cards" id="ema-rv-cards">${renderCardsHtml()}</div>
        ${renderLoadMoreHtml()}
      </div>
    `;

    attachEvents();
  }

  // ── Event binding ──────────────────────────────────────────────────────────────

  function attachEvents() {
    // Open form
    const openBtn = document.getElementById('ema-rv-open-form');
    if (openBtn) {
      openBtn.addEventListener('click', () => {
        state.formVisible  = true;
        state.formRating   = 0;
        state.formError    = '';
        state.formTitleValue = '';
        state.formBodyValue  = '';
        render();
        const wrap = document.getElementById('ema-rv-form-wrap');
        if (wrap) wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }

    // Cancel form
    const cancelBtn = document.getElementById('ema-rv-cancel');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', () => {
        state.formVisible = false;
        state.formError   = '';
        render();
      });
    }

    // Star picker
    const picker = root.querySelector('.ema-rv-star-picker');
    if (picker) {
      picker.addEventListener('click', e => {
        const starEl = e.target.closest('[data-star]');
        if (!starEl) return;
        state.formRating = parseInt(starEl.dataset.star, 10);
        // Save current input values before re-rendering
        const titleEl = document.getElementById('ema-rv-title');
        const bodyEl  = document.getElementById('ema-rv-body');
        if (titleEl) state.formTitleValue = titleEl.value;
        if (bodyEl)  state.formBodyValue  = bodyEl.value;
        render();
      });

      picker.addEventListener('mouseover', e => {
        const starEl = e.target.closest('[data-star]');
        if (!starEl) return;
        const hoverN = parseInt(starEl.dataset.star, 10);
        picker.querySelectorAll('[data-star]').forEach((el, i) => {
          el.classList.toggle('filled', i < hoverN);
        });
      });

      picker.addEventListener('mouseleave', () => {
        picker.querySelectorAll('[data-star]').forEach((el, i) => {
          el.classList.toggle('filled', i < state.formRating);
        });
      });
    }

    // Submit
    const submitBtn = document.getElementById('ema-rv-submit');
    if (submitBtn) {
      submitBtn.addEventListener('click', handleSubmit);
    }

    // Load more
    const loadMoreBtn = document.getElementById('ema-rv-load-more');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', handleLoadMore);
    }
  }

  // ── Submit handler ────────────────────────────────────────────────────────────

  function handleSubmit() {
    const titleEl = document.getElementById('ema-rv-title');
    const bodyEl  = document.getElementById('ema-rv-body');

    const titleVal = titleEl ? titleEl.value.trim() : '';
    const bodyVal  = bodyEl  ? bodyEl.value.trim()  : '';

    // Save to state
    state.formTitleValue = titleVal;
    state.formBodyValue  = bodyVal;

    // Client-side validation
    if (!state.formRating) {
      state.formError = 'Please select a star rating.';
      render();
      return;
    }
    if (!bodyVal || bodyVal.length < 10) {
      state.formError = 'Your review must be at least 10 characters.';
      render();
      return;
    }
    if (bodyVal.length > 2000) {
      state.formError = 'Your review must not exceed 2000 characters.';
      render();
      return;
    }
    if (titleVal.length > 200) {
      state.formError = 'Title must not exceed 200 characters.';
      render();
      return;
    }

    state.submitting = true;
    state.formError  = '';
    render();

    submitReview({
      product_handle: state.productHandle,
      customer_id:    state.customerId,
      author_name:    state.customerName || 'Customer',
      rating:         state.formRating,
      title:          titleVal || null,
      body:           bodyVal,
    })
      .then(() => {
        state.submitting  = false;
        state.formSuccess = true;
        state.formVisible = false;
        render();
        // Refresh review list
        return loadInitial();
      })
      .catch(err => {
        state.submitting = false;
        state.formError  = err.message || 'Could not submit your review. Please try again.';
        render();
      });
  }

  // ── Load more handler ─────────────────────────────────────────────────────────

  function handleLoadMore() {
    if (state.loading) return;
    state.loading = true;
    render();

    const nextPage = state.page + 1;
    fetchReviews(nextPage)
      .then(data => {
        state.reviews = state.reviews.concat(data.reviews || []);
        state.page    = nextPage;
        state.total   = data.total || 0;
        state.hasMore = state.reviews.length < state.total;
        state.loading = false;
        render();
      })
      .catch(() => {
        state.loading = false;
        render();
      });
  }

  // ── Initial load ──────────────────────────────────────────────────────────────

  function loadInitial() {
    state.loading = true;
    state.page    = 1;
    state.reviews = [];
    render();

    return fetchReviews(1)
      .then(data => {
        state.reviews = data.reviews || [];
        state.summary = data.summary || null;
        state.total   = data.total   || 0;
        state.limit   = data.limit   || 10;
        state.hasMore = state.reviews.length < state.total;
        state.loading = false;
        render();
        injectProductBadge(state.summary);
        autoOpenFormIfRequested();
      })
      .catch(err => {
        console.warn('[EMA Reviews] Failed to load reviews:', err);
        state.loading = false;
        state.reviews = [];
        render();
      });
  }

  // Auto-open the write-review form when ?open_review=1 is in the URL.
  // Used by the post-purchase review invitation email.
  function autoOpenFormIfRequested() {
    if (new URLSearchParams(window.location.search).get('open_review') !== '1') return;
    const openBtn = document.getElementById('ema-rv-open-form');
    if (!openBtn) return;
    openBtn.click();
  }

  // ── Init ──────────────────────────────────────────────────────────────────────

  function init() {
    const section = document.querySelector('.ema-rv-section');
    if (!section) {
      console.warn('[EMA Reviews] .ema-rv-section not found in DOM');
      return;
    }

    root = document.getElementById('ema-rv-root');
    if (!root) {
      console.warn('[EMA Reviews] #ema-rv-root not found in DOM');
      return;
    }

    // Read config from data attributes
    state.productHandle = section.dataset.handle  || '';
    state.apiBase       = (section.dataset.api    || '').replace(/\/$/, '');
    state.customerId    = section.dataset.customerId   || '';
    state.customerName  = section.dataset.customerName || '';
    state.loggedIn      = section.dataset.loggedIn === 'true';

    console.log('[EMA Reviews] init — handle:', state.productHandle, '| loggedIn:', state.loggedIn);

    if (!state.productHandle || !state.apiBase) {
      console.warn('[EMA Reviews] Missing data-handle or data-api');
      return;
    }

    injectStyles();

    // ── Relocate into the product-info column, after the last disclosure ──────
    // On desktop the product-info column is 47% wide (float:right).
    // On mobile it is full-width (no float). Placing the review panel here
    // satisfies both layouts without any JS viewport checks.
    var productInfoCol = document.querySelector('.product-info__sticky') ||
                         document.querySelector('.product-info');
    if (productInfoCol && section.parentNode !== productInfoCol) {
      section.classList.remove('page-width');
      var disclosures = Array.from(productInfoCol.querySelectorAll('details.disclosure'));
      var insertAfterEl = null;
      if (disclosures.length > 0) {
        var lastDisc = disclosures[disclosures.length - 1];
        var el = lastDisc;
        while (el && el.parentNode !== productInfoCol) { el = el.parentNode; }
        if (el && el.parentNode === productInfoCol) { insertAfterEl = el; }
      }
      if (insertAfterEl && insertAfterEl.nextSibling) {
        productInfoCol.insertBefore(section, insertAfterEl.nextSibling);
      } else if (insertAfterEl) {
        productInfoCol.appendChild(section);
      } else {
        productInfoCol.appendChild(section);
      }
    }

    // Render loading skeleton immediately
    root.innerHTML = `
      <h2 class="ema-rv-heading">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="#f59e0b" stroke="#f59e0b" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
        Customer Reviews
      </h2>
      <div class="ema-rv-body">
        <div class="ema-rv-cards">${renderSkeleton()}</div>
      </div>
    `;

    loadInitial();
  }

  // ── Inline star badge (product page) ─────────────────────────────────────────

  function renderStarSvgs(avg, size) {
    size = size || 16;
    var full  = Math.floor(avg);
    var half  = (avg - full) >= 0.5 ? 1 : 0;
    var empty = 5 - full - half;
    var out   = '';
    // full stars
    for (var i = 0; i < full; i++) {
      out += '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="#f59e0b" stroke="#f59e0b" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
    }
    // half star
    if (half) {
      out += '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" stroke="#f59e0b" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><defs><linearGradient id="ema-half"><stop offset="50%" stop-color="#f59e0b"/><stop offset="50%" stop-color="none" stop-opacity="0"/></linearGradient></defs><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" fill="url(#ema-half)"/></svg>';
    }
    // empty stars
    for (var j = 0; j < empty; j++) {
      out += '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
    }
    return out;
  }

  function injectProductBadge(summary) {
    if (!summary || summary.count === 0) return;

    // Don't inject twice
    if (document.querySelector('.ema-star-badge')) return;

    var avg   = parseFloat(summary.average) || 0;
    var count = summary.count;
    var label = count === 1 ? '1 review' : count + ' reviews';

    var badge  = document.createElement('a');
    badge.href = '#ema-rv-root';
    badge.className = 'ema-star-badge';
    badge.setAttribute('aria-label', avg.toFixed(1) + ' out of 5, ' + label);
    badge.innerHTML =
      '<span class="ema-star-badge__stars">' + renderStarSvgs(avg, 16) + '</span>' +
      '<span class="ema-star-badge__count">' + label + '</span>';

    badge.addEventListener('click', function(e) {
      e.preventDefault();
      var target = document.getElementById('ema-rv-root');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Insert after the price block — look for afterpay/subscriptions first, then price block.
    // On mobile the layout is single-column so .product-info__sticky is just a plain div;
    // we can still use it — the badge just renders inline before the product form.
    var productInfoCol = document.querySelector('.product-info__sticky') ||
                         document.querySelector('.product-info');
    if (!productInfoCol) return;

    // Find insertion point: after the Afterpay/subscriptions app block,
    // falling back to after the price block.
    // Fish/coral/invert templates use id containing "subscriptions_app_block";
    // dry-goods template uses id containing "afterpay".
    var anchorInner = productInfoCol.querySelector('[id*="subscriptions_app_block"]') ||
                      productInfoCol.querySelector('[id*="afterpay"]')                 ||
                      productInfoCol.querySelector('[class*="subscriptions"]')         ||
                      productInfoCol.querySelector('.product-price');

    if (anchorInner) {
      // Walk up to the direct child of productInfoCol
      var el = anchorInner;
      while (el && el.parentNode !== productInfoCol) { el = el.parentNode; }
      if (el && el.parentNode === productInfoCol) {
        productInfoCol.insertBefore(badge, el.nextSibling);
        return;
      }
    }

    // Last resort: prepend
    productInfoCol.insertBefore(badge, productInfoCol.firstChild);
  }

  // ── Boot ──────────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
